export let PROJECTS = [
    {
        "projectNumber" : "16-911",
        "description" : "KSK Neumarkt Sanitärbereich Vorstand 5.OG",
        "client" : "Kreissparkasse Köln",
        "responsibleEmployes" : "Bob der Baumeister",
        "projectStatus" : "abgeschlossen",
        "invoiceStatus" : "schlussgerechnet",
        "projectStart" : "01-08-2016",
        "projectYear" : "2016",
        "comment" : "mit Frau Demonte Klever",
    },
    {
        "projectNumber" : "16-222",
        "description" : "ZSB Auf Ab Tiefbau",
        "client" : "Emschergenossenschaft",
        "responsibleEmployes" : "Bob der Baumeister, Hecken",
        "projectStatus" : "abgeschlossen",
        "invoiceStatus" : "schlussgerechnet",
        "projectStart" : "30-08-2016",
        "projectYear" : "2016",
        "comment" : "",
    },
      {
        "projectNumber" : "16-006",
        "description" : "BV Wallisch Sankt Augustin",
        "client" : "Private Bauherren",
        "responsibleEmployes" : "Bob der Baumeister, Hecken",
        "projectStatus" : "abgeschlossen",
        "invoiceStatus" : "schlussgerechnet",
        "projectStart" : "31-08-2016",
        "projectYear" : "2016",
        "comment" : "",  
      }
]


// WEBPACK FOOTER //
// ./src/providers/mock-projects.ts